var map = {
	"./BOOK COLOR.png": 123,
	"./BOOK.png": 249,
	"./Wood Apple (1).png": 921,
	"./Wood Apple.png": 390,
	"./abhigyan.jpg": 495,
	"./english1.jpg": 867,
	"./hindi1.jpg": 450,
	"./mat.jpg": 194,
	"./math1.jpg": 501,
	"./rock.jpg": 414,
	"./science.jpg": 978,
	"./science1.jpg": 202,
	"./vyakaran1.jpg": 149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;